import React from 'react';
import { CheckIcon } from 'lucide-react';
import { TransformCta } from '../TransformCta';
const KNOW = ['Qué observar primero.', 'Qué analizar después.', 'Qué información realmente cambia un plan de tratamiento.', 'Cuándo confiar en el análisis facial.', 'Cuándo utilizar la cefalometría para confirmar tus hallazgos.', 'Y cómo llegar a una decisión clínica con mayor seguridad.'];
export function Vision() {
  return <section className="w-full bg-navy-900 px-4 py-14 text-white sm:py-20" data-id="element-302" data-mp="3qzeknqyd3ifi">
      <div className="mx-auto max-w-2xl" data-id="element-303" data-mp="3v0gc3lm1eq6x">
        <h2 className="text-center font-display text-[25px] font-bold leading-[1.18] tracking-tight sm:text-4xl" data-id="element-304" data-mp="3uzeypahjtrm1">
          Imagina evaluar cualquier paciente siguiendo el mismo proceso que utilizan los
          especialistas con <span className="text-gold-300" data-id="element-305" data-mp="dl0174xe996b">mayor experiencia</span>
        </h2>

        <p className="mt-6 text-center text-[13px] font-bold uppercase tracking-[0.14em] text-gold-300" data-id="element-306" data-mp="dix7a9t4evwb">
          Un sistema donde sabes…
        </p>

        <ul className="mt-5 space-y-2.5" data-id="element-307" data-mp="3d6kp1pyku7i7">
          {KNOW.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/5 px-4 py-3" data-id="element-308" data-mp="385x0rc1qg4ro">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold-500" data-id="element-309" data-mp="339g1pmszw5zt">
                <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-310" data-mp="2z84grul2g8xy" />
              </span>
              <span className="text-[14.5px] font-medium leading-snug text-white/90 sm:text-base" data-id="element-311" data-mp="3qwxwzsbgxm7j">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="mt-7 text-center text-[15px] leading-relaxed text-white/70 sm:text-[17px]" data-id="element-312" data-mp="3m44vref7kw07">
          Eso es exactamente lo que encontrarás dentro del{' '}
          <strong className="font-semibold text-white" data-id="element-313" data-mp="ihxrwrr1joey">Sistema de Diagnóstico Facial</strong>.
        </p>

        <TransformCta headline="Pasa de la incertidumbre diagnóstica a decidir con confianza." label="Quiero seguir el proceso de los especialistas" location="vision" tone="dark" data-id="element-314" data-mp="dpmhuw2l6m8o" />
      </div>
    </section>;
}